export default {
	methods: {
		hasCustomerAccountLink(contactObj) {
			return "UserCustomer" in contactObj && contactObj.UserCustomer && contactObj.link_accepted == 1
		},
		hasAccountLink(contactObj) {
			return ("CompanyLink" in contactObj && contactObj.CompanyLink) || ("UserLink" in contactObj && contactObj.UserLink)
		},
		accountLinked(contactObj) {
			return (this.hasAccountLink(contactObj) && contactObj.link_accepted == 1) || this.hasCustomerAccountLink(contactObj)
		},
		accountLinkKey(contactObj) {
			if ("UserCustomer" in contactObj && contactObj.UserCustomer)
				return "UserCustomer"
			else if ("CompanyLink" in contactObj && contactObj.CompanyLink)
				return "CompanyLink"
			else if ("UserLink" in contactObj && contactObj.UserLink)
				return "UserLink"
		},
		fetchContact(idOrSlug,includes) {
			let vm = this

			return new Promise((resolve,reject) => {

				let params = {
					useLinkedData: true
				}

				if (includes)
					params.include = includes

				vm.getJSON("Contact/find/"+idOrSlug,params).then(response => {

					vm.$store.contact = response.data

					resolve(response)
				})

			})
		},
		documentEmailRecipients(customer,subContactList) {

			let contacts = [
				{
					name: customer.name,
					email: customer.email,
					id: customer.id
				}
			]

			if (subContactList)
				contacts = contacts.concat(subContactList)

			contacts = contacts.filter(contact => {
				if (contact.email)
					return true
			})

			let options = contacts.map(contact => {
				contact.value = contact.id
				contact.text = contact.name + " (" + contact.email + ")"

				return contact
			})

			return options

		}
	}
}
